import { BADGE_CATALOG } from '../utils/badges';

const SIZE = {
  xs: 'w-4 h-4',
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
  xl: 'w-20 h-20',
};

/**
 * Renders a single badge image. Use `size` prop to control dimensions.
 * Hover / tap shows a tooltip via the title attribute.
 */
export const UserBadge = ({ code, size = 'sm', className = '' }) => {
  const meta = BADGE_CATALOG[code];
  if (!meta) return null;
  return (
    <img
      src={meta.image}
      alt={meta.name}
      title={`${meta.name} — ${meta.description}`}
      className={`${SIZE[size] || SIZE.sm} object-contain badge-shimmer-sm ${className}`}
      data-testid={`user-badge-${code}`}
    />
  );
};

/**
 * Wraps a circular avatar and overlays up to `maxBadges` badges at the bottom-right.
 *
 * @param {object} props
 *  - src: avatar image url
 *  - alt: alt text
 *  - badges: array of badge codes (strings)
 *  - avatarSize: pixel-based className for the avatar ring (e.g. "w-16 h-16")
 *  - badgeSize: "xs" | "sm" | "md" | "lg"
 *  - maxBadges: how many to show (default 2)
 */
export const AvatarWithBadges = ({
  src,
  alt = '',
  badges = [],
  avatarSize = 'w-16 h-16',
  badgeSize = 'sm',
  maxBadges = 2,
  fallback = null,
  className = '',
}) => {
  const visible = (badges || []).filter((b) => BADGE_CATALOG[b]).slice(0, maxBadges);
  return (
    <div className={`relative inline-block ${className}`}>
      {src ? (
        <img
          src={src}
          alt={alt}
          className={`${avatarSize} rounded-full object-cover border-2 border-border`}
        />
      ) : (
        fallback
      )}
      {visible.length > 0 && (
        <div className="absolute -bottom-1 -right-1 flex -space-x-1">
          {visible.map((code) => (
            <UserBadge key={code} code={code} size={badgeSize} />
          ))}
        </div>
      )}
    </div>
  );
};
